<h1 class="mb-3 text-22 text-center">Forgot Password</h1>
<form class="fade-in" [formGroup]="forgotPasswordForm" (ngSubmit)="submit()">
    <label for="email">Email Address</label>
    <input type="email" class="form-control" id="email" placeholder="Enter Email Address" formControlName="email"
           [class.is-invalid]="forgotPasswordForm.get('email').invalid && forgotPasswordForm.get('email').touched">
    <div class="k-form-error" *ngIf="forgotPasswordForm.get('email').invalid && (forgotPasswordForm.get('email').touched ||
    forgotPasswordForm.get('email').dirty)">
        <div *ngIf="forgotPasswordForm.get('email').hasError('required') || forgotPasswordForm.get('email').hasError('whitespace')">
            Email Address is required
        </div>
        <div *ngIf="forgotPasswordForm.get('email').hasError('email')">
            Invalid Email Address
        </div>
    </div>

    <button type="submit" class="btn btn-rounded btn-primary primary-btn btn-block mt-2" [class.k-loader--loading]="state.post">
        Send Request <span class="k-loader k-loader--light k-loader--right" *ngIf="state.post"></span>
    </button>
</form>
<div class="mt-3 text-center">
    <a class="text-muted" (click)="goBack()">
        <u>Go Back</u>
    </a>
</div>

















